import { setTokens, setUser } from "@lib/stores";
import { saveThenReturnAuthData } from "@modules/api/util/authHelper";

export const onLogin = async (token: string) => {
  console.log(token);

  if (
    !(
      (window as any)?.webkit?.messageHandlers?.b2bLoginHandler?.postMessage ||
      (window as any)?.JSBridge?.onLogin
    )
  ) {
    const data = JSON.parse(token);

    saveThenReturnAuthData(data);

    setUser(data);
    setTokens(data);
  }

  try {
    (window as any)?.webkit?.messageHandlers?.b2bLoginHandler?.postMessage?.(
      token
    );
  } catch (e) {
    alert(e);
  }
  try {
    (window as any)?.JSBridge?.onLogin?.(token);
  } catch (e) {
    alert(e);
  }
};

export const handlingClose = async () => {
  try {
    (window as any)?.webkit?.messageHandlers?.closeHandler?.postMessage?.(null);
  } catch (e) {
    alert(e);
  }
  try {
    (window as any)?.JSBridge?.onNavigateUp?.();
  } catch (e) {
    alert(e);
  }
};
